/*
 * @Author: Raeesaa Metkari
 * @Date: 2020-08-21 17:58:10
 * @Last Modified by: Raeesaa Metkari
 * @Last Modified time: 2020-08-22 01:45:36
 */
import { SelectFileButton } from '@components/UI-Components/SelectFileButton'
import {
  PopupSize,
  StandardPopup
} from '@components/UI-Components/StandardPopup/StandardPopup'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  fileUploadWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: '20px 0px'
  },
  descriptionContainer: {
    padding: '5px 8px',
    maxWidth: 448
  },
  description: {
    padding: '5px 5px 5px 18px',
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  descriptionText: {
    display: 'list-item'
  },
  uploadError: {
    marginTop: 10,
    textAlign: 'center',
    color: '#ac2828'
  }
}))

interface MyProps {
  uploadInProgress: boolean
  title?: string
  uploadButtonLabel?: string
  fileMimeType: string
  uploadError?: string
  handleChange: (file: any) => void
  onClickSave: (e?: any) => void
  onClickClose: (e?: any) => void
  fileUploadSummary: any
  nextButtonLabel?: string
  cancelButtonLabel?: string
  disableNext?: boolean
  descriptionElement?: React.ReactElement
}

export const FileUploadDialog: React.FunctionComponent<MyProps> = (props: MyProps) => {
  const {
    uploadInProgress,
    onClickSave,
    handleChange,
    onClickClose,
    title,
    uploadButtonLabel,
    fileMimeType,
    uploadError,
    fileUploadSummary,
    nextButtonLabel,
    cancelButtonLabel,
    disableNext,
    descriptionElement
  } = props
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <StandardPopup
      cancelHandler={onClickClose}
      saveHandler={onClickSave}
      maxWidth={PopupSize.large}
      nextButtonLabel={nextButtonLabel || t('common.label.upload', 'Upload')}
      popupTitle={title || t('common.label.uploadFile', 'Upload File')}
      isSaveInProgress={uploadInProgress}
      cancelButtonLabel={cancelButtonLabel}
      disableNext={disableNext}
    >
      <div className={classes.fileUploadWrapper}>
        {fileUploadSummary ? (
          <div dangerouslySetInnerHTML={{ __html: fileUploadSummary }}></div>
        ) : (
          <>
            <SelectFileButton
              accept={`${fileMimeType}`}
              label={`${
                uploadButtonLabel ||
                t('common.label.selectPDFFile', 'Select File (*.pdf)')
              }`}
              handleChange={file => handleChange(file)}
              disabled={uploadInProgress}
              loading={uploadInProgress}
            />

            <div className={classes.descriptionContainer}>{descriptionElement}</div>

            {uploadError ? (
              <Typography className={classes.uploadError}>{uploadError}</Typography>
            ) : null}
          </>
        )}
      </div>
    </StandardPopup>
  )
}
